import { render, staticRenderFns } from "./BubbleMenuImage.vue?vue&type=template&id=5f16e604&scoped=true&"
import script from "./BubbleMenuImage.vue?vue&type=script&lang=js&"
export * from "./BubbleMenuImage.vue?vue&type=script&lang=js&"
import style0 from "./BubbleMenuImage.vue?vue&type=style&index=0&id=5f16e604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16e604",
  null
  
)

export default component.exports